import { render, staticRenderFns } from "./DatasetSources.vue?vue&type=template&id=2c2657cd&scoped=true"
import script from "./DatasetSources.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetSources.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DatasetSources.vue?vue&type=style&index=0&id=2c2657cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2657cd",
  null
  
)

export default component.exports